import { createSelector } from 'reselect'
import { RootState } from '../store'


const getWaterTestParams = (state: RootState)=> state.waterTestParams.data || []
const isLoading = (state: RootState)=> state.waterTestParams.loading
const error = (state: RootState)=> state.waterTestParams.error

const makeWaterTestParamsValues = createSelector(
  [getWaterTestParams],
  (params)=>{

    const items = params.map(param => {
      const {values, colors} = param
      const concat_value= values.reduce((acc, curr, idx)=> {
        acc.push( {
          value: curr,
          color: colors[idx] || colors[param.colors.length - 1],
        })
        return acc
      }, [] as {value: number, color: string}[])

      return {
        ...param,
        values: concat_value,
        unit: param.measurement
      }
    })

    return items
  }
)

interface GroupedParams {
  [key:string]: {group_description: string, params: string[]}
}
const makeGroupedParams = createSelector(
  [getWaterTestParams],
  (params): GroupedParams=>{
    const groupedByName = params.reduce((acc, item): GroupedParams => {
      if(!item.group_name) return acc;
      if (!acc[item.group_name]) {
        acc[item.group_name] = {
          group_description: item.group_description,
          params: [],
        }
      }
      acc[item.group_name].params.push(item.name)
      return acc
    }, {})
    return groupedByName;
  }
)




export const WaterTestParamsSelectors = {
  getWaterTestParams,
  isLoading,
  error,
  makeWaterTestParamsValues,
  makeGroupedParams,
}